module.exports = __webpack_public_path__ + "static/media/2020.7.1情景党课.63fea212.jpg";